<template>
  <div>
    <!-- <h1>{{ $store.getters.getImgId }}</h1>
    <h1>{{ $store.getters.getImgFile }}</h1> -->
    <div class="card mt-2 mb-2 ms-5 me-5">
      <div class="card-body row">
        <div class="col-12 col-sm-5">
          <img :src="serverUrl + 'images/forms/' +
            imageFile" class="img-fluid img-thumbnail" :alt="'Imagen:' + imageInfo.imageName" />
        </div>
        <div class="container col-12 col-sm-7 border">
          <div>
            <h4 class="mt-3 mb-3">Dimensiones del producto</h4>
          </div>
          <table class="table-responsive">
            <tbody>
              <tr>
                <td colspan="">
                  <div v-if="showDistances" class="border-end">
                    <div class="row m-1" v-for="(distance, index) in D.length" :key="index">
                      <div class="col">
                        <label class="lblform mx-1">Distancia L{{ index + 1 }}:</label>
                      </div>
                      <div class="mx-1 col">
                        <input type="number" class="form-control mx-1 avilable-input" :id="'D' + index" v-model="D[index]"
                          min="0" />
                        cm.
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="">
                  <div v-if="showDiameters" class="border-end">
                    <div class="row m-1" v-for="(diametre, index) in DT.length" :key="index">
                      <div class="col">
                        <label class="lblform mx-auto">Diámetro D{{ index + 1 }}:</label>
                      </div>
                      <div class="mx-auto col">
                        <input type="number" class="form-control mx-auto avilable-input" :id="'DT' + index"
                          v-model="DT[index]" min="0" />
                        cm.
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="">
                  <div v-if="showRadius" class="border-end">
                    <div class="row m-1" v-for="(radius, index) in R.length" :key="index">
                      <div class="col">
                        <label class="lblform mx-auto">Radio R{{ index + 1 }}:</label>
                      </div>
                      <div class="mx-auto col">
                        <input type="number" class="form-control mx-auto avilable-input" :id="'R' + index"
                          v-model="R[index]" min="0" />
                        cm.
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="">
                  <div v-if="showAngles" class="border-end">
                    <div class="row m-1" v-for="(angle, index) in A.length" :key="index">
                      <div class="col">
                        <label class="lblform mx-auto">Ángulo A{{ index + 1 }}:</label>
                      </div>
                      <div class="mx-auto col">
                        <input type="number" class="form-control mx-auto avilable-input" :id="'A' + index"
                          v-model="A[index]" min="0" />
                        °.
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  watch: {
    D: {
      handler: "solveConceptions",
      deep: true,
    },
    A: {
      handler: "solveConceptions",
      deep: true,
    },
    R: {
      handler: "solveConceptions",
      deep: true,
    },
    DT: {
      handler: "solveConceptions",
      deep: true,
    },
  },
  data() {
    return {
      serverUrl: RUTA_SERVIDOR,
      //Variables desde el store
      imageId: 0,
      imageFile: "",
      titleX: "Dimensiones del producto",
      //Info general de la imagen que almaceno luego de hacer get con el Id
      imageInfo: [],
      //Valor interativo de cada dimensión con v-model
      D: [],
      A: [],
      R: [],
      DT: [],
      //Enseñar labels and inputs según las dimensiones
      showDistances: false,
      showAngles: false,
      showRadius: false,
      showDiameters: false,
      //Formulación
      conceptionLength: "0",
      conceptionWidth: "0",
    };
  },
  beforeMount() {
    this.imageId = this.$store.getters.getImgId;
    this.imageFile = this.$store.getters.getImgFile;
    axios
      .get(RUTA_SERVIDOR + "api/sheet/image/get", {
        params: {
          sheetImg_id: this.imageId,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.imageInfo = res.data[0];
        if (this.imageInfo) {
          this.getDimensions();
        } else {
          console.error("Error: Image info is undefined.");
        }
      })
      .catch((err) => console.error(`There has been an error ${err}`));
  },
  methods: {
    getDimensions() {
      if (this.imageInfo.length == 0) {
        alert("Por favor espere un momento!");
      } else {
        if (this.imageInfo["imgDistances"] > 0) {
          //console.log("enters the distances condition");
          this.showDistances = true;
          // Initialize the A array with zeros
          this.D = Array(this.imageInfo["imgDistances"]).fill(0);
        }
        else {
          // Si imgDistances es 0, aún así inicializar D
          this.D = [];
        }
        if (this.imageInfo["imgAngles"] > 0) {
          //console.log("enters the angles condition");
          this.showAngles = true;
          // Initialize the A array with zeros
          this.A = Array(this.imageInfo["imgAngles"]).fill(0);
        }
        else {
          // Si imgDistances es 0, aún así inicializar D
          this.A = [];
        }
        if (this.imageInfo["imgRadius"] > 0) {
          //console.log("enters the radius condition");
          this.showRadius = true;
          // Initialize the R array with zeros
          this.R = Array(this.imageInfo["imgRadius"]).fill(0);
        }
        else {
          // Si imgDistances es 0, aún así inicializar D
          this.R = [];
        }
        if (this.imageInfo["imgDiameters"] > 0) {
          //console.log("enters the diameters condition");
          this.showDiameters = true;
          // Initialize the DT array with zeros
          this.DT = Array(this.imageInfo["imgDiameters"]).fill(0);
        }
        else {
          // Si imgDistances es 0, aún así inicializar D
          this.DT = [];
        }
      }
      this.conceptionLength = this.imageInfo["imgConceptionLength"];
      //console.log(this.conceptionLength);
      this.conceptionWidth = this.imageInfo["imgConceptionWidth"];
      //console.log(this.conceptionWidth);
      this.$emit("sendSheetImgInfo", this.imageInfo);
    },
    solveConceptions() {
      var hasNonZeroValuesDistances = this.D.every(function (value) {
        return value !== 0;
      });
      var hasNonZeroValuesAngles = this.A.every(function (value) {
        return value !== 0;
      });
      var hasNonZeroValuesRadius = this.R.every(function (value) {
        return value !== 0;
      });
      var hasNonZeroValuesDiameters = this.DT.every(function (value) {
        return value !== 0;
      });

      if (
        hasNonZeroValuesDistances &&
        hasNonZeroValuesAngles &&
        hasNonZeroValuesRadius &&
        hasNonZeroValuesDiameters
      ) {
        this.transformConceptions();
      } else {
        console.log("No se puede calcular el desarrollo");
      }
    },
    transformConceptions() {
      //Array para alamacenar ancho y largo (Final) del producto
      let arrayDevelops = [];

      // Construir y ejecutar la expresión aritmética para el cálculo del desarrollo
      let lengthResult = Math.round(this.buildExpression(this.conceptionLength, this.D, this.DT, this.R, this.A));
      let widthResult = Math.round(this.buildExpression(this.conceptionWidth, this.D, this.DT, this.R, this.A));

      // Inprimir el resultado del cálculo del desarrollo
      //console.log("Conception Length:", lengthResult);
      //console.log("Conception Width:", widthResult);

      // -- Añadir los desarrollos al array inicial
      arrayDevelops.push(lengthResult);
      arrayDevelops.push(widthResult);
      // console.log(arrayDevelops);

      //Almacenar los desarrollos en vuex 
      this.$store.dispatch("addDevelopsAction", arrayDevelops);

      //Emitir dos argumentos en un emit tipo clave - valor (Ejemplo)
      //this.$emit("sendDt&Rd", { diameters: this.DT,radius: this.R });

      this.$emit("sendMeasures", { distances: this.D, diameters: this.DT, radius: this.R, angles: this.A });
    },
    buildExpression(conception, D, DT, R, A) {
      try {
        // Reemplazar las variables en la fórmula con los valores correspondientes
        var conceptionValues = conception
          .replace(/D\[(\d+)\]/g, function (match, p1) {
            return D[p1];
          })
          .replace(/DT\[(\d+)\]/g, function (match, p1) {
            return DT[p1];
          })
          .replace(/R\[(\d+)\]/g, function (match, p1) {
            return R[p1];
          })
          .replace(/A\[(\d+)\]/g, function (match, p1) {
            return A[p1];
          });

        // Evaluar la fórmula con los valores reemplazados
        var result = eval(conceptionValues);
        return result;
      } catch (error) {
        console.error("Error al evaluar la fórmula:", error);
        return NaN; // o algún otro valor que indique un error en la evaluación
      }
    },
  },
};
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
  max-width: 140px;
}
</style>